import { jsxs as l, jsx as e } from "react/jsx-runtime";
const d = () => /* @__PURE__ */ l(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_864_10180)", children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
            fill: "#F3F3FD"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M50.4337 57.2853L72 37.9936C71.1863 36.2341 69.3064 35 67.1155 35H29.8845C27.6926 35 25.8147 36.2331 25 37.9926L46.5823 57.2853C47.6454 58.2382 49.3706 58.2382 50.4337 57.2853Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M50.6475 57.0178C49.5729 57.9502 47.829 57.9502 46.7545 57.0178L24.939 38.1396C24.6587 38.7263 24.5005 39.3714 24.5005 40.0498V66.6615C24.5005 69.3338 26.9066 71.5 29.8762 71.5H67.5096C70.4782 71.5 72.8853 69.3338 72.8853 66.6615V40.0498C72.8853 39.3714 72.7271 38.7273 72.4469 38.1407L50.6475 57.0178Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M67.5559 71H29.4441C26.4378 71 24 68.851 24 66.2V39.8C24 37.149 26.4378 35 29.4441 35H67.5559C70.5623 35 73 37.149 73 39.8V66.2C73 68.851 70.5623 71 67.5559 71Z",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M72 38.016L50.4996 57.2616C49.3998 58.2461 47.6177 58.2461 46.518 57.2616L25 38",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M58 38C58 30.269 64.268 24 72 24C79.731 24 86 30.269 86 38C86 45.732 79.731 52 72 52C64.268 52 58 45.732 58 38Z",
            fill: "var(--plac-icon-fill-active)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M78.5771 34L71.4202 41.1569L68 37.7357",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        )
      ] }),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_864_10180", children: /* @__PURE__ */ e("rect", { width: "100", height: "100", fill: "white" }) }) })
    ]
  }
);
export {
  d as EmailIllustration
};
//# sourceMappingURL=index.es472.js.map
